import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _isLoading = new BehaviorSubject<boolean>(false);
  public readonly isLoading = this._isLoading.asObservable();
  private loadingRequestCount = 0;

  show() {
    this.loadingRequestCount++;
    if (this.loadingRequestCount === 1) {
      this._isLoading.next(true);
    }
  }

  hide() {
    this.loadingRequestCount--;
    if (this.loadingRequestCount === 0) {
      this._isLoading.next(false);
    }
  }
}
